import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import cn from 'classnames';
import { DragHandle } from '../../icons/essentials/DragHandle';
import styles from './SortableList.module.scss';
export function SortableListItem(param) {
    let { id, children, itemTestId, handleTestId, dragLabel, className } = param;
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };
    return /*#__PURE__*/ _jsxs("li", _object_spread_props(_object_spread({
        ref: setNodeRef,
        style: style,
        className: cn(styles.row, {
            [styles.isDragging]: isDragging
        }, className),
        "data-testid": itemTestId,
        "aria-label": dragLabel
    }, attributes, listeners), {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles.dragHandle,
                "data-testid": handleTestId,
                "aria-hidden": "true",
                children: /*#__PURE__*/ _jsx(DragHandle, {
                    size: 16
                })
            }),
            children
        ]
    }));
}
